import {
    Breadcrumb,
    Button,
    Card,
    Form,
    Input,
    Modal,
    Popover,
    Upload,
  } from "antd";
  import { useCallback, useState } from "react";
  import { useLocation, useNavigate } from "react-router";
  import { NumericFormat } from "react-number-format";
  import SendMoneyService from "../../services/send-money.service";
  import { useEffect } from "react";
  import {
    allowOnlyAlphabets,
    allowOnlyNumbers,
    amountFormat,
  } from "../../services/common.service";
  import profileIcon from "../../assests/images/profile_large.jpg";
  import avatar1 from "../../assests/icons/avatar1.png";
  import avatar2 from "../../assests/icons/avatar2.png";
  import avatar3 from "../../assests/icons/avatar3.png";
  import avatar4 from "../../assests/icons/avatar4.png";
  import avatar5 from "../../assests/icons/avatar5.png";
  import avatar6 from "../../assests/icons/avatar6.png";
  import avatar7 from "../../assests/icons/avatar7.png";
  import avatar8 from "../../assests/icons/avatar8.png";
  import avatar9 from "../../assests/icons/avatar9.png";
  import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
  import { FiUpload } from "react-icons/fi";
  import { modeSelector } from "../../store/selectors/app.selector";
  import { useSelector } from "react-redux";
  import { CONFIG } from "../../environment";
  import AccountCard from "../../components/account-card";
  import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
  import OTP from "../../components/otp";
  import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
  import { useTranslation } from "react-i18next";
  
  const avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    // avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
  ];
  
  export default function ModifyPesaLinkBene() {
    const navigate = useNavigate();
    const [stage, setStage] = useState(1);
    const [formDetails, setFormDetails] = useState({});
    const [loader, setLoader] = useState(false);
    const [verifyDetails, setVerifyDetails] = useState({});
    const [message, setMessage] = useState("");
    const [form] = Form.useForm();
    const [payeeDetails, setPayeeDetails] = useState({});
    const location = useLocation();
    const [payeeImage, setPayeeImage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setDeleteShowModal] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
    const mode = useSelector(modeSelector);
    const [otp, setOtp] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);
    const [cancelVisible, setCancelVisible] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
      if (location.state) {
        setPayeeDetails(location.state);
        form.setFieldsValue({
          beneAccNo: location.state?.beneAccNo,
          beneName: location.state?.beneName || "-",
          beneNickName: location.state?.beneNickName,
          maxTransferLimit: location.state?.maxTransferLimit,
          bankName: location.state?.bankName,
          beneBrn: location.state?.beneBrn,
          beneEmail: location.state?.beneEmail,
          beneMobileNo: location.state?.beneMobileNo,
        });
        getPayeeImages(location.state);
      }
    }, []);
  
    const handleUploadChange = (info) => {
      const file = info.file;
      if (file) {
        convertImageToBase64(file, (base64String) => {
          updatePayeeImage(base64String);
        });
      }
    };
  
    const convertImageToBase64 = (file, callback) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        const base64String = reader.result;
        callback(base64String);
      });
      reader.readAsDataURL(file);
    };
  
    const getPayeeImages = useCallback(
      async (payeeDetails) => {
        try {
          setPopoverVisible(false);
          const req = {
            accNo: [payeeDetails.beneAccNo],
          };
          setLoader(true);
          const response = await SendMoneyService.getPayeeImages(req);
          if (response.status === 200) {
            setLoader(false);
            setPayeeImage(response.data["data"]["imagesList"][0]?.imageData);
          }
        } catch (error) {
          setLoader(false);
        }
      },
      [payeeDetails]
    );
  
    const updatePayeeImage = useCallback(
      async (values) => {
        try {
          setPopoverVisible(false);
          const req = {
            accNo: payeeDetails.beneAccNo,
            imageData: values,
          };
          setLoader(true);
          const response = await SendMoneyService.updatePayeeImage(req);
          if (response.status === 200) {
            setLoader(false);
            setMessage(response.data["message"]);
            setShowModal(true);
          }
        } catch (error) {
          setLoader(false);
        }
      },
      [payeeDetails]
    );
  
    const deleteProfileImage = useCallback(async () => {
      try {
        const req = {
          accNo: payeeDetails.beneAccNo,
        };
        setLoader(true);
        setDeleteShowModal(false);
        const response = await SendMoneyService.removePayeeImage(req);
  
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setShowDeleteSuccess(true);
        }
      } catch (error) {
        setLoader(false);
      }
    }, [payeeDetails, payeeImage]);
  
    const content = (
      <ul className="profile-options p-3 text-center" style={{ width: "220px" }}>
        <div className="row ">
          {avatars.map((avatar, index) => (
            <li className="col-4 pb-2" key={index}>
              <img
                src={avatar}
                alt="Profile"
                height="50"
                style={{ borderRadius: "100%" }}
                onClick={() => updatePayeeImage(avatar)}
              />
            </li>
          ))}
        </div>
        <li className="text-center mt-1">
          <Upload
            accept="image/*"
            beforeUpload={() => false}
            onChange={handleUploadChange}
            showUploadList={false}
          >
            <FiUpload
              title={t("pages.profile.upload_photo", {
                defaultValue: "Upload Photo",
              })}
              size={"30"}
              style={{
                color: "#00cc99",
                padding: "5px",
                border: "2px dotted #00cc99",
                borderRadius: "20px",
              }}
            />
            <br />
            <span style={{ color: "#00cc99" }}>
              {" "}
              {t("pages.profile.upload_photo", {
                defaultValue: "Upload Photo",
              })}
            </span>
          </Upload>
        </li>
      </ul>
    );
  
    const onVerify = useCallback(
      async (values) => {
        try {
          setLoader(true);
          const requestParams = {
            reqId: payeeDetails.reqId,
            authType: "A",
            beneAccNo: payeeDetails?.beneAccNo,
            beneNickName: values?.beneNickName,
            beneType: "PESALINK",
            maxTransferLimit:
              values?.maxTransferLimit !== undefined
                ? parseInt(
                    values?.maxTransferLimit.toString().replaceAll(/,/g, "")
                  )
                : "",
  
            beneEmail: values?.beneEmail || "",
            beneMobileNo: values?.beneMobileNo || "",
            otp: "",
          };
          setFormDetails({ ...requestParams });
          const response1 = await SendMoneyService.modifyPayeeVerify(
            requestParams
          );
  
          if (response1.status === 200) {
            setLoader(false);
            setVerifyDetails(response1.data);
            // if (response1.data["otpEnabled"]) {
            setStage(2);
            //  }
          }
          setStage(2);
        } catch (error) {
          setLoader(false);
        }
      },
      [payeeDetails]
    );
  
    const handleResendOtp = useCallback(async () => {
      try {
        const response1 = await SendMoneyService.modifyPayeeVerify({
          ...formDetails,
        });
        if (response1.status === 200) {
          setLoader(false);
        }
      } catch (error) {}
    }, [formDetails]);
  
    const onConfirm = useCallback(async (values) => {
      try {
        setLoader(true);
        const response = await SendMoneyService.modifyPayeeConfirm({
          ...values,
        });
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setSuccessVisible(true);
        }
      } catch (error) {
        setLoader(false);
        setOtp("");
      }
    }, []);
  
    function renderSwitch() {
      switch (stage) {
        case 1:
          return renderForm();
  
        case 2:
          return renderConfirm();
  
        case 3:
          return (
            <OTP
              otp={otp}
              setOtp={setOtp}
              onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
              handleResendOtp={() => handleResendOtp(formDetails)}
              cancelTransaction={() => {
                navigate("/pesaLink/manage-beneficiary");
              }}
              type="COMMON"
            />
          );
  
        default:
          return renderForm();
      }
    }
  
    function renderForm() {
      return (
        <>
          {" "}
          <Form
            layout="vertical"
            initialValues={formDetails}
            onFinish={onVerify}
            form={form}
          >
            <div className=" profile-details">
              <div align="center">
                {payeeImage !== null && payeeImage?.length > 0 ? (
                  <img
                    src={payeeImage}
                    alt="Profile"
                    height={130}
                    width={130}
                    style={{ backgroundColor: "#108ee9" }}
                  />
                ) : (
                  <img src={profileIcon} alt="Profile" height={130} />
                )}
  
                <div
                  style={{
                    position: "relative",
                    width: "fit-content",
                    transform: "translate(-50%, -50%)",
                    marginLeft: "10px",
                  }}
                >
                  <Popover
                    placement="right"
                    content={content}
                    trigger="hover"
                    open={popoverVisible}
                    onOpenChange={setPopoverVisible}
                  >
                    <MdOutlineEdit
                      style={{
                        fontSize: 20,
                        cursor: "pointer",
                        color: "white",
                        width: 30,
                        height: 30,
                        position: "absolute",
                        left: 30,
                        bottom: 8,
                        backgroundColor: "#00cc99",
                        borderRadius: "20px",
                        padding: "5px",
                      }}
                    />
                  </Popover>
                  {payeeImage && (
                    <div
                      placement="right"
                      onClick={() => setDeleteShowModal(true)}
                    >
                      <MdDeleteOutline
                        style={{
                          fontSize: 20,
                          cursor: "pointer",
                          color: "white",
                          width: 30,
                          height: 30,
                          position: "absolute",
                          left: 30,
                          bottom: 100,
                          backgroundColor: "red",
                          borderRadius: "20px",
                          padding: "5px",
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
  
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 row">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    name="beneName"
                    label={t("pages.Add_Bene.bane_name", {
                      defaultValue: "Beneficiary Name",
                    })}
                  >
                    <Input
                      onPaste={(evet) => {
                        evet.preventDefault();
                        return false;
                      }}
                      maxLength={30}
                      placeholder={t("pages.Add_Bene.bane_name", {
                        defaultValue: "Beneficiary Name",
                      })}
                      readOnly
                      size="large"
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    name="beneNickName"
                    label={t("pages.Add_Bene.bene_nick_name", {
                      defaultValue: "Beneficiary Nick Name",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.bene_nick_name_req", {
                          defaultValue: "Beneficiary Nick Name is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={30}
                      placeholder={t("pages.Add_Bene.bene_nick_name", {
                        defaultValue: "Beneficiary Nick Name",
                      })}
                      size="large"
                      onKeyPress={(e) => allowOnlyAlphabets(e)}
                    />
                  </Form.Item>
                </div>
  
                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    name="beneAccNo"
                    label={t("common.account_no_lbl", {
                      defaultValue: "Account Number",
                    })}
                  >
                    <Input
                      maxLength={18}
                      placeholder={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      readOnly
                      size="large"
                    />
                  </Form.Item>
                </div>
  
                <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                  <Form.Item
                    name="bankName"
                    label={t("pages.sendMoney.payee.bank_name", {
                      defaultValue: "Bank Name",
                    })}
                  >
                    <Input
                      placeholder={t("pages.sendMoney.payee.bank_name", {
                        defaultValue: "Bank Name",
                      })}
                      readOnly
                      size="large"
                    />
                  </Form.Item>
                </div>
  
                <div>
                  <Form.Item
                    name="maxTransferLimit"
                    label={t("pages.transfer_limit.transfer_limit", {
                      defaultValue: "Transfer Limit",
                    })}
                    rules={[
                      {
                        required: true,
                        message: t("pages.Add_Bene.transfer_limit_req", {
                          defaultValue: "Transfer Limit is required",
                        }),
                      },
                      {
                        validator: (_, value) => {
                          if (parseFloat(value) <= 0) {
                            return Promise.reject(
                              "Transfer Limit should be greater than 0"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      maxLength={12}
                      size="large"
                      placeholder={t("pages.transfer_limit.transfer_limit", {
                        defaultValue: "Transfer Limit",
                      })}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end mt-4">
                <Button
                  type="default"
                  onClick={() => navigate("/pesaLink/manage-beneficiary")}
                  size="large"
                  className="secondary-btn "
                >
                  {" "}
                  {t("buttons.cancel_btn", {
                    defaultValue: "Cancel",
                  })}
                </Button>
  
                <Button
                  htmlType="submit"
                  type="primary"
                  className="primary-btn mx-4"
                  //loading={loader}
                  size="large"
                >
                  {" "}
                  {t("buttons.next_btn", {
                    defaultValue: "Next",
                  })}
                </Button>
              </div>
            </div>
          </Form>
        </>
      );
    }
  
    function renderConfirm() {
      return (
        <>
          <h5 className="mb-3 bold-text">
            {t("common.confirmation", {
              defaultValue: "Confirmation",
            })}
          </h5>
  
          <p className="mb-4" style={{ fontSize: 14 }}>
            {t("pages.Add_Bene.please_check_bene_details", {
              defaultValue:
                "Please check the beneficiary details carefully, before you proceed",
            })}
          </p>
          <div className=" profile-details" align="center">
            {payeeImage !== null && payeeImage?.length > 0 ? (
              <img
                src={payeeImage}
                alt="Profile"
                height={120}
                width={120}
                style={{ backgroundColor: "#108ee9" }}
              />
            ) : (
              <img src={profileIcon} alt="Profile" height={120} />
            )}
          </div>
          <div className="confirm-details mt-2">
            <div className="row ">
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}
                </label>
                <span>{payeeDetails?.beneName || "-"}</span>
              </div>
  
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.Add_Bene.bene_nick_name", {
                    defaultValue: "Beneficiary Nick Name",
                  })}
                </label>
                <span>{formDetails?.beneNickName}</span>
              </div>
  
              <div className="confirm-label-wrapper">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span> {payeeDetails?.beneAccNo || "-"}</span>
              </div>
  
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.sendMoney.payee.bank_name", {
                    defaultValue: "Bank Name",
                  })}
                </label>
                <span>{payeeDetails?.bankName}</span>
              </div>
  
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.sendMoney.payee.branch_name", {
                    defaultValue: "Branch Name",
                  })}
                </label>
                <span>{payeeDetails?.beneBrn}</span>
              </div>
  
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.transfer_limit.transfer_limit", {
                    defaultValue: "Transfer Limit",
                  })}
                </label>
  
                <span>
                  {formDetails?.maxTransferLimit
                    ? amountFormat(
                        formDetails?.maxTransferLimit,
                        payeeDetails?.beneCurrency
                      )
                    : "-"}
                </span>
              </div>
            </div>
          </div>
  
          <div className="d-flex align-items-center justify-content-end mt-4">
            <Button
              type="default"
              onClick={() => setStage(1)}
              size="large"
              className="secondary-btn mx-3"
            >
              {" "}
              {t("buttons.back_btn", {
                defaultValue: "Back",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn hide-xs"
              onClick={() =>
                verifyDetails["otpEnabled"]
                  ? setStage(3)
                  : onConfirm({
                      ...formDetails,
                      ...{ otp: CONFIG.DEFAULT_OTP },
                    })
              }
              size="large"
            >
              {" "}
              {t("pages.Add_Bene.modify_beneficiary", {
                defaultValue: "Modify Beneficiary",
              })}
            </Button>
  
            <Button
              type="primary"
              className="primary-btn hide-lg"
              onClick={() =>
                verifyDetails["otpEnabled"]
                  ? setStage(3)
                  : onConfirm({
                      ...formDetails,
                      ...{ otp: CONFIG.DEFAULT_OTP },
                    })
              }
              size="large"
            >
              {" "}
              {t("buttons.modify_btn", {
                defaultValue: "Modify",
              })}
            </Button>
          </div>
        </>
      );
    }
  
    return (
      <>
          <Breadcrumb separator=">">
            {/* <Breadcrumb.Item>
              <span onClick={() => navigate("/dashboard")}>
                {t("navigation.home", {
                  defaultValue: "Home",
                })}
              </span>
            </Breadcrumb.Item> */}
            <Breadcrumb.Item>
              <span onClick={() => navigate("/pesaLink")}>
                Pesalink
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => navigate("/pesaLink/manage-beneficiary")}
            >
              <span>
                {" "}
                {t("pages.Add_Bene.manage_beneficiaries", {
                  defaultValue: "Manage Beneficiaries",
                })}
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Pesalink Beneficiary
              </span>
            </Breadcrumb.Item>
          </Breadcrumb>
        <Card size="small" className="mb-1 text-center breadcrumb-title-card">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
              {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
              <h3 className="title mb-0">
                {" "}
                {t("pages.Add_Bene.manage_beneficiaries", {
                  defaultValue: "Manage Beneficiaries",
                })}
              </h3>
            </div>
          </div>
        </Card>
        <div className="row d-flex justify-content-between">
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountCard />
            </Card>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <Card className="application-card card-padding">
              {renderSwitch()}
            </Card>
          </div>
        </div>
        <Modal
          title=""
          open={showModal}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={true}
        >
          <div style={{ width: 350, margin: "0 auto" }} align="center">
            <TickIcon height={65} />
            <h4 className="mb-3 mt-2">
              {" "}
              {t("common.success", {
                defaultValue: "Success",
              })}
            </h4>
            <p>{message}</p>{" "}
            <div align="center">
              <Button
                size="large"
                style={{ width: 130 }}
                type="primary"
                onClick={() => {
                  setShowModal(false);
                  getPayeeImages(payeeDetails);
                }}
              >
                {t("buttons.okay_btn", {
                  defaultValue: "Okay",
                })}
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title={t("pages.Add_Bene.delete_beneficiary_image", {
            defaultValue: "Delete Beneficiary Image",
          })}
          visible={showDeleteModal}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={false}
        >
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.Add_Bene.delete_bene_img", {
              defaultValue:
                "Are you sure you want to delete your Beneficiary image?",
            })}
          </p>
          <div align="right" className="mt-3">
            <Button
              className="secondary-btn mx-4"
              type="default"
              onClick={() => {
                setDeleteShowModal(false);
              }}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
  
            <Button type="primary" onClick={() => deleteProfileImage()}>
              {t("common.yes", { defaultValue: "Yes" })}
            </Button>
          </div>
        </Modal>
        <Modal
          title={""}
          visible={showDeleteSuccess}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={false}
        >
          <div style={{ width: 350, margin: "0 auto" }} align="center">
            <TickIcon height={65} />
            <h4 className="mb-3 mt-2">
              {" "}
              {t("common.success", {
                defaultValue: "Success",
              })}
            </h4>
            <p>{message}</p>{" "}
            <div align="center">
              <Button
                size="large"
                style={{ width: 130 }}
                type="primary"
                onClick={() => {
                  setShowDeleteSuccess(false);
                  getPayeeImages(payeeDetails);
                }}
              >
                {t("buttons.okay_btn", {
                  defaultValue: "Okay",
                })}
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title={""}
          open={successVisible}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={true}
          // className="custom-error-modal"
        >
          <div style={{ margin: "0 auto" }} align="center">
            <TickIcon height={65} />
            <h4 className="mb-3 mt-2">
              {" "}
              {t("common.success", {
                defaultValue: "Success",
              })}
            </h4>
            <p>{message}</p>
  
            <div align="center">
              <Button
                size="large"
                style={{ width: 130 }}
                onClick={() => {
                  setSuccessVisible(false);
                  navigate("/pesaLink/manage-beneficiary");
                }}
                type="primary"
              >
                {t("buttons.okay_btn", {
                  defaultValue: "Okay",
                })}
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title={t("common.cancal", {
            defaultValue: "Cancel ?",
          })}
          open={cancelVisible}
          footer={null}
          width={350}
          closable={false}
          maskClosable={false}
          mask={true}
        >
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("common.commont_otp_desc", {
              defaultValue:
                "If you cancel this now, you will have to start over. Are you sure you want to cancel?",
            })}
          </p>
          <div className="mt-3" align="right">
            <Button
              className="secondary-btn"
              type="default"
              onClick={() => setCancelVisible(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn"
              style={{ marginLeft: 20 }}
              onClick={() => {
                setCancelVisible(false);
                navigate("/send-money/manage-beneficiary");
              }}
            >
              {t("common.yes", { defaultValue: "Yes" })}
            </Button>
          </div>
        </Modal>
      </>
    );
  }
  